import React, { HTMLAttributes } from 'react';

import cn from 'classnames';
import { createPortal } from 'react-dom';

import { useCloseOnEscape } from '@shared/hooks/useCloseOnEscape';
import { Icon, UiButton } from '@shared/ui';

import cls from './Sidebar.module.css';

interface ISidebarProps extends HTMLAttributes<HTMLDivElement> {
    isOpen: boolean;
    children: React.ReactNode;
    onClose?: () => void;
    width?: number | string;
    className?: string;
    rootClassName?: string;
    innerRef?: React.Ref<HTMLDivElement>;
}

export const Sidebar = ({
    isOpen,
    onClose,
    children,
    width = 757,
    className,
    rootClassName,
    innerRef,
    ...rest
}: ISidebarProps) => {
    useCloseOnEscape({ isOpen, onCloseHandler: onClose, capture: false });

    if (typeof document === 'undefined') return null;

    return createPortal(
        <div
            className={cn(cls.root, isOpen ? cls.rootOpen : cls.rootClosing, rootClassName)}
            aria-modal="true"
            role="dialog"
            ref={innerRef}
            {...rest}
        >
            <div className={cn(cls.panel, className)} style={{ width }}>
                {children}
                <UiButton
                    variant="icon"
                    startIcon={<Icon iconName="cross" fill="white" width={12} height={12} />}
                    onClick={onClose}
                    className={cls.closeBtn}
                >
                    Close
                </UiButton>
            </div>
        </div>,
        document.body
    );
};
